let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fKD9g")).then(() => parcelRequire('1WAgc'));